export default {
  label: 'Authors',
  placeholder: 'All',
  other: 'other',
  others: 'others',
  all: 'All',
  filtered: 'filtered',
  filteredPlural: 'filtered',
  negated: 'negated',
  negatedPlural: 'negated',
};
